export const FILTER_KEYS = {
  FORMATO: "formato",
  MARCAS: "marca",
  CONCENTRACION: "concentracion",
  GENERO: "sexo",
  PROMO: "promocion",
  DESTACADO: "destacado",
  NO_STOCK: "noStock",
} as const;

//PROMO y NOSTOCK son checkbox, xq necesito poder checkear y deschequear (los radio btns si son unicos no pueden deschequearse una vez chequeados)
export const promoCbox = {
  //esta es la key q uso en el backend
  name: FILTER_KEYS.PROMO,
  value: "Promos",
};
export const noStockCbox = {
  //esta es la key q uso en el backend
  name: FILTER_KEYS.NO_STOCK,
  value: "Productos sin stock",
};
export const destacadoCbox = {
  //esta es la key q uso en el backend
  name: FILTER_KEYS.DESTACADO,
  value: "Productos destacados",
};

export interface ToBeUpdatedDueToNotSolid {
  header: string;
  type: "checkbox" | "radio";
  radioUnits: { name: string; valueANDid: string; label?: string }[];
}

export const grupoRadiosNoAdmin: ToBeUpdatedDueToNotSolid[] = [
  {
    header: "Formato",
    radioUnits: [
      { name: FILTER_KEYS.FORMATO, valueANDid: "individual" },
      { name: FILTER_KEYS.FORMATO, valueANDid: "tester" },
      { name: FILTER_KEYS.FORMATO, valueANDid: "estuche" },
    ],
    type: "radio",
  },
  {
    header: "Tipo de fragancia",
    radioUnits: [
      {
        name: FILTER_KEYS.CONCENTRACION,
        valueANDid: "EDT",
        label: "Eau de toilette",
      },
      {
        name: FILTER_KEYS.CONCENTRACION,
        valueANDid: "EDP",
        label: "Eau de parfum",
      },
      {
        name: FILTER_KEYS.CONCENTRACION,
        valueANDid: "EDC",
        label: "Eau de cologne",
      },
    ],
    type: "radio",
  },
  {
    header: "Género",
    radioUnits: [
      { name: FILTER_KEYS.GENERO, valueANDid: "Masculino" },
      { name: FILTER_KEYS.GENERO, valueANDid: "Unisex" },
      { name: FILTER_KEYS.GENERO, valueANDid: "Femenino" },
    ],
    type: "radio",
  },
  {
    header: "Promoción",
    radioUnits: [
      {
        name: promoCbox.name,
        valueANDid: promoCbox.value,
        label: "Productos en oferta",
      },
    ],
    //a single radio btn cant be unchecked once checked,thats why I use a CBOX
    type: "checkbox",
  },
];

//al admin le agrego el NO STOCK
export const grupoRadiosAdmin: ToBeUpdatedDueToNotSolid[] = [
  ...grupoRadiosNoAdmin,
  {
    header: "Sin stock",
    radioUnits: [
      {
        name: noStockCbox.name,
        valueANDid: noStockCbox.value,
        label: "Productos sin stock",
      },
    ],
    //a single radio btn cant be unchecked once checked,thats why I use a CBOX
    type: "checkbox",
  },
  {
    header: "Destacados",
    radioUnits: [
      {
        name: destacadoCbox.name,
        valueANDid: destacadoCbox.value,
        label: "Productos destacados",
      },
    ],
    //a single radio btn cant be unchecked once checked,thats why I use a CBOX
    type: "checkbox",
  },
];
